import { SupportedLanguage } from "@next-platform/client-common-core";

import translations from "@/localization";

export const getLocalResources = (languageCode: SupportedLanguage): Record<string, string> => {
  return Object.values(translations).reduce<Record<string, string>>((acc, translationModule) => {
    return {
      ...acc,
      ...((translationModule as Record<string, Record<string, string>>)?.[languageCode] ?? {}),
    };
  }, {});
};
